import { render, staticRenderFns } from "./qyxjh.vue?vue&type=template&id=5c32dbd1&scoped=true"
import script from "./qyxjh.vue?vue&type=script&lang=js"
export * from "./qyxjh.vue?vue&type=script&lang=js"
import style0 from "./qyxjh.vue?vue&type=style&index=0&id=5c32dbd1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c32dbd1",
  null
  
)

export default component.exports